import { useEffect } from "react";
import { useParams } from "react-router-dom";
import ErrorHandler from "../../helpers/ErrorHandler";
import "react-confirm-alert/src/react-confirm-alert.css";
import { NotificationMessage } from "../../helpers/Types";
import { AxiosError, AxiosInstance, AxiosResponse } from "axios";

interface ShortUrlRedirectProps {
  setNotificationMessage: (notificationMessage: NotificationMessage) => void;
  api: AxiosInstance;
  updateUsername: (username: string) => void;
}

export default function ShortUrlRedirect({ setNotificationMessage, api, updateUsername }: ShortUrlRedirectProps) {
  let { code } = useParams();

  useEffect(() => {
    api
      .get(`short_url/get/${code}`)
      .then((response: AxiosResponse) => {
        if (response.data) window.location.replace(response.data.link.S);
      })
      .catch((error: AxiosError) => {
        ErrorHandler(error, setNotificationMessage);
        updateUsername("");
      });
  }, [code, api, setNotificationMessage, updateUsername]);

  return <p></p>;
}
